// Origineel: client/imports/ui/Tasks/TaskState.tsx (de provider staat in ./Providers.tsx)
import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';

/**
 * De taken die de speler op het eigen takenscherm kiest, tot hij ze speelt. Niet in het
 * origineel: daar volgde deze keuze ook de gedeelde selectie van de server, waardoor de eigen
 * keuze weg was na een bezoek aan de fabriek. Het gezamenlijke scherm toont nu de selectie van
 * de server (`sharedSelectedTasks`) zelf.
 *
 * Niet in het origineel: de keuze staat ook in de browser (zie `eigenKeuze.ts`). Het
 * takenscherm zegt met `bewaarOnder` voor welk spel, welke speler en welke week de keuze
 * geldt; bij een andere sleutel komt de keuze uit de browser, anders is hij leeg.
 */
export type TaskStateWaarde = {
  selectedTasks: string[];
  setSelectedTasks: Dispatch<SetStateAction<string[]>>;
  bewaarOnder: (sleutel: string) => void;
};

export const TaskStateContext = createContext<TaskStateWaarde | undefined>(undefined);

export const useTaskState = (): TaskStateWaarde => {
  const waarde = useContext(TaskStateContext);
  if (!waarde) throw new Error('useTaskState must be used within a TaskStateContext');
  return waarde;
};
